'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var TableResponsive = require('../TableResponsive/TableResponsive.js');
require('./_index.scss.js');

var _excluded = ["className", "md"];
var CLASSNAME = 'varta-table-markdown',
    cnColumnTitle = "".concat(CLASSNAME, "__column-title"),
    cnCell = "".concat(CLASSNAME, "__cell"),
    cnRow = "".concat(CLASSNAME, "__row");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function TableMarkdown(_ref) {
  var className = _ref.className,
      md = _ref.md,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var headerColumn = false;

  function mdToArray() {
    var lines = md.split(/\\r\\n|\\n/);
    var isHeader = true;
    return lines.map(function (l) {
      if (l.match(/^\|---+/)) {
        isHeader = false;
        return undefined;
      }

      if (l.match(/^\|:---+:\|/)) {
        isHeader = false;
        headerColumn = true;
        return undefined;
      }

      return l.replace(/(^\|\s)|(\s\|($))/g, '').split(' | ').map(function (c, i) {
        if (isHeader && c) {
          return /*#__PURE__*/React__default.createElement("b", {
            key: "1"
          }, c);
        }

        if (headerColumn && !i && c) {
          return /*#__PURE__*/React__default.createElement("b", {
            className: cnColumnTitle,
            key: "1"
          }, c);
        }

        return c;
      });
    });
  }

  return /*#__PURE__*/React__default.createElement(TableResponsive, _rollupPluginBabelHelpers.extends({
    items: mdToArray(),
    headerColumn: headerColumn,
    classNameCell: cnCell,
    classNameRow: cnRow,
    className: classNames(CLASSNAME, className)
  }, props));
}
TableMarkdown.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Markdown string */
  md: PropTypes.string.isRequired
};
TableMarkdown.defaultProps = {
  md: ''
};

module.exports = TableMarkdown;
